import { module } from 'modujs';
import Splide from '@splidejs/splide';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {};
    this.DOM.view = this.el;

    this.create();
  }

  create() {
    this.slideshow = new Splide(this.DOM.view, {
      pagination: false,
      arrows: false,
      padding: { left: 60, right: 60 },
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: 48,
      pauseOnHover: false,
      rewind: true,
      drag: false,
      arrowPath: 'M5 14.4453L12 7.94531L5 1.44531',
      breakpoints: {
        640: {
          type: 'loop',
          drag: true,
          pagination: true,
          arrows: true,
          perPage: 1,
          gap: 30,
          fixedWidth: '100%',
          padding: { left: 30, right: 30 },
        },
      },
    });

    this.slideshow.mount();
  }

  destroy() {
    console.log('des');
    this.slideshow.destroy();
  }
}
